import * as ApiHelper from "../api/ApiHelper";
import { type AddToCartApiItem } from "../Cart/api/AddToCart";
import { resolveApiUrl } from "../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/quote/list/checkout");

export function sendDataMultipleQuotes(data: { quoteNumber: string; items: AddToCartApiItem[] }[]) {
  const packageToCartForm = JSON.stringify(data);

  return fetch(apiUrl, {
    body: packageToCartForm,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  })
    .then((result) => {
      window.SCHA.updateMinicart?.();
      return result;
    })
    .then((result) => {
      return result;
    });
}
